// avstemming-shell-messages translations (Norwegian source catalog).
window.PlummeI18n.register('no', {
  'avcs.common.cancel': 'Avbryt',
  'avcs.common.open': 'Åpne',
  'avcs.common.requestDocs': 'Be om dokumentasjon',
  'avcs.common.ofCount': '{done} av {total}',
  'avcs.common.unknown': 'Ukjent',
  'avcs.common.version': 'Versjon {version}',
  'avcs.common.docsMissing': '{count} dokumenter mangler',
  'avcs.common.reset': 'Nullstill',
  'avcs.common.status': 'Status',
  'avcs.common.period': 'Periode',
  'avcs.common.responsible': 'Ansvarlig',
  'avcs.common.deadline': 'Frist',
  'avcs.common.client': 'Klient',
  'avcs.common.deviation': 'Avvik',
  'avcs.common.deviations': '{count} avvik',
  'avcs.common.notRelevant': 'Ikke relevant',
  'avcs.common.notStarted': 'Ikke startet',
  'avcs.common.wholePeriodWord': 'Hele perioden',
  'avcs.area.bank': 'Bank',
  'avcs.area.receivables': 'Kundefordringer',
  'avcs.area.payables': 'Leverandørgjeld',
  'avcs.area.payroll': 'Lønn',
  'avcs.area.vat': 'MVA',
  'avcs.area.tax': 'Skatt og offentlige avgifter',
  'avcs.area.assets': 'Eiendeler',
  'avcs.area.loans': 'Lån og gjeld',
  'avcs.area.equity': 'Egenkapital',
  'avcs.area.other': 'Øvrig balanse',
  'avcs.area.periodControls': 'Periodekontroller',
  'avcs.reason.externalBalanceMissing': 'Ekstern saldo mangler.',
  'avcs.reason.unexplainedDifference': 'Differansen er ikke forklart.',
  'avcs.reason.explanationMissingReason': 'En forklaring mangler begrunnelse.',
  'avcs.reason.documentationMissing': 'Dokumentasjon mangler — legg ved bilag eller skriv et notat.',
  'avcs.reason.lineAssessmentMissingComment': 'En vurdering av en banklinje mangler begrunnelsen den krever.',
  'avcs.reason.checklistIncomplete': 'Ett eller flere punkter i den faglige sjekklista er ikke vurdert.',
  'avcs.reason.criticalDeviationUnexplained': 'Et kritisk punkt står som avvik uten begrunnelse.',
  'avcs.rollforward.opening': 'Inngående saldo',
  'avcs.rollforward.movement': 'Bevegelse i perioden',
  'avcs.rollforward.closing': 'Utgående saldo',
  'avcs.rollforward.drift': 'Ikke forklart av inngående saldo og bevegelse',
  'avcs.kontroll.noDeadline': 'Ingen kontrollfrist',
  'avcs.kontroll.overdueOne': 'Kontrollfrist {date} · passert med {days} dag',
  'avcs.kontroll.overdueMany': 'Kontrollfrist {date} · passert med {days} dager',
  'avcs.kontroll.today': 'Kontrollfrist i dag',
  'avcs.kontroll.inOne': 'Kontrollfrist {date} · om {days} dag',
  'avcs.kontroll.inMany': 'Kontrollfrist {date} · om {days} dager',
  'avcs.kontroll.bannerTitle': 'Kontroll av {scope} · {period}',
  'avcs.kontroll.basisAt': ' · datagrunnlag per {time}',
  'avcs.kontroll.performedBy': 'Utført av {name}',
  'avcs.kontroll.deviationsInBasis': '{count} avvik i grunnlaget',
  'avcs.kontroll.progress': 'Kontrollfremdrift: {done} av {total} punkter',
  'avcs.kontroll.reconProgress': 'Avstemming: {progress} % utført',
  'avcs.kontroll.waitingDocs': 'Venter på dokumentasjon: {request}',
  'avcs.kontroll.waitingDue': ' · frist {date}',
  'avcs.kontroll.sendRequest': 'Send forespørsel',
  'avcs.kontroll.whatMissing': 'Hva mangler',
  'avcs.kontroll.whatMissingHint': 'Kontrollen holdes åpen, men kan ikke godkjennes før forespørselen er besvart.',
  'avcs.kontroll.whatMissingPlaceholder': 'Beskriv hvilken dokumentasjon du trenger for å kunne gå god for arbeidet',
  'avcs.kontroll.deadlineOptional': 'Frist (valgfritt)',
  'avcs.kontroll.summaryTitle': 'Kontrollsammendrag — {scope}',
  'avcs.kontroll.performedByLabel': 'Utført av',
  'avcs.kontroll.versionLabel': 'Versjon',
  'avcs.kontroll.dataBasis': 'Datagrunnlag',
  'avcs.kontroll.asOf': 'Per {time}',
  'avcs.kontroll.materiality': 'Vesentlighetsgrense',
  'avcs.kontroll.notSet': 'Ikke satt',
  'avcs.kontroll.criticalDeviations': 'Kritiske avvik',
  'avcs.kontroll.missingDocs': 'Manglende dokumentasjon',
  'avcs.kontroll.remainingRisk': 'Gjenstående risiko',
  'avcs.kontroll.notDescribed': 'Ikke beskrevet ennå.',
  'avcs.kontroll.approvedByLabel': 'Godkjent av',
  'avcs.kontroll.periodContext': 'Periodekontekst: {progress} % utført · {avvik} avvik · {mangler} dokumenter mangler totalt (blokkerer ikke denne kontrollen)',
  'avcs.kontroll.noneOpen': 'Ingen kontroll er åpen.',
  'avcs.kontroll.blockPerformer': 'Du utførte dette arbeidet og kan ikke kontrollere det.',
  'avcs.kontroll.blockUnassessed': '{count} kontrollpunkter er ikke vurdert.',
  'avcs.kontroll.blockMustFixOne': '{count} punkt står som «Må rettes».',
  'avcs.kontroll.blockMustFixMany': '{count} punkter står som «Må rettes».',
  'avcs.kontroll.blockNoteEmpty': 'En merknad mangler tekst.',
  'avcs.kontroll.blockDocsRequest': 'Dokumentforespørselen er ikke besvart.',
  'avcs.kontroll.blockConclusion': 'Kontrollen har avvik eller merknader. Da må konklusjonen skrives.',
  'avcs.kontroll.blockAreaOpen': 'Fagområdet {area} er ikke ferdig kontrollert.',
  'avcs.kontroll.blockAreasOpen': '{count} fagområder i perioden er ikke ferdig kontrollert.',
  'avcs.kontroll.pointsAssessed': '{done} av {total} punkter vurdert',
  'avcs.kontroll.pointsBreakdown': '{ok} OK · {notes} merknad · {mustFix} må rettes',
  'avcs.kontroll.performerNotice': 'Du utførte dette arbeidet, og kan derfor ikke kontrollere det. Kontroll krever en annen person.',
  'avcs.kontroll.changedAfterNotice': 'Regnskapet er endret etter at kontrollen ble godkjent. Godkjenningen står, men den hviler ikke lenger på tallene som gjelder nå.',
  'avcs.kontroll.returnedNotice': 'Returnert til utfører: {note}',
  'avcs.kontroll.points': 'Kontrollpunkter',
  'avcs.kontroll.noPoints': 'Kontrollen har ingen punkter.',
  'avcs.kontroll.approvedBy': 'Godkjent av {name}. {conclusion}',
  'avcs.kontroll.reviewerConclusion': 'Kontrollørens konklusjon',
  'avcs.kontroll.conclusionPlaceholder': 'Hva bygger godkjenningen på?',
  'avcs.kontroll.reopenPrompt': 'Hvorfor gjenåpnes kontrollen?',
  'avcs.kontroll.reopen': 'Gjenåpne kontrollen',
  'avcs.kontroll.markDocsReceived': 'Marker dokumentasjonen som mottatt',
  'avcs.kontroll.returnPlaceholder': 'Hva må rettes?',
  'avcs.kontroll.returnToPerformer': 'Returner til utfører',
  'avcs.kontroll.approveScope': 'Godkjenn {scope}',
  'avcs.kontroll.approvePeriod': 'Godkjenn perioden',
  'avcs.kontroll.history': 'Historikk',
  'avcs.cell.reconciled': 'Avstemt',
  'avcs.cell.notChecked': 'Ikke kontrollert',
  'avcs.matrix.noResponsible': 'Ingen ansvarlig',
  'avcs.overall.done': 'Ferdig',
  'avcs.overall.working': 'Arbeid',
  'avcs.matrix.sortBy': 'Sorter etter {name}',
  'avcs.matrix.noClients': 'Ingen klienter matcher filtrene.',
  'avcs.matrix.progress': 'Fremdrift',
  'avcs.matrix.org': 'Org. {org}',
  'avcs.matrix.noOrg': 'Uten org.nr.',
  'avcs.matrix.openAreaFor': 'Åpne {area} for {client}',
  'avcs.matrix.openFolder': 'Åpne mappa',
  'avcs.matrix.noTasks': 'Ingen åpne avstemmingsoppgaver matcher filtrene.',
  'avcs.activity.periodOpened': 'åpnet perioden',
  'avcs.activity.periodLocked': 'låste perioden',
  'avcs.activity.periodReopenedReason': 'gjenåpnet perioden – {reason}',
  'avcs.activity.periodReopened': 'gjenåpnet perioden',
  'avcs.activity.accountUpdatedStatus': 'oppdaterte konto {account} ({status})',
  'avcs.activity.accountUpdated': 'oppdaterte konto {account}',
  'avcs.activity.basisChanged': 'bokført saldo på {account} endret seg etter avstemming',
  'avcs.activity.commentAdded': 'skrev en kommentar',
  'avcs.activity.documentAddedOnAccount': 'la ved {file} på konto {account}',
  'avcs.activity.documentAdded': 'la ved {file}',
  'avcs.activity.aDocument': 'et dokument',
  'avcs.activity.documentRemoved': 'fjernet {file}',
  'avcs.activity.requestCreated': 'ba klienten om {subject}',
  'avcs.activity.documentation': 'dokumentasjon',
  'avcs.activity.requestUpdated': 'oppdaterte en kundeforespørsel',
  'avcs.activity.none': 'Ingen aktivitet registrert i denne perioden ennå.',
  'avcs.comments.none': 'Ingen kommentarer ennå.',
  'avcs.comments.visibleToClient': 'Synlig for klienten',
  'avcs.comments.internal': 'Intern',
  'avcs.comments.placeholder': 'Skriv en kommentar',
  'avcs.comments.add': 'Legg til',
  'avcs.panel.tab.documents': 'Dokumenter',
  'avcs.panel.tab.review': 'Kontroll',
  'avcs.panel.tab.comments': 'Kommentarer',
  'avcs.panel.tab.activity': 'Aktivitet',
  'avcs.panel.tab.requests': 'Forespørsler',
  'avcs.panel.notSent': 'Perioden er ikke sendt til kontroll ennå. «Send hele perioden til kontroll» ligger i toppen.',
  'avcs.panel.controlDue': ' · frist {date}',
  'avcs.panel.controlPerformedBy': ' · utført av {name}',
  'avcs.panel.openInReview': 'Åpne i kontrollflaten',
  'avcs.panel.approvalNote': 'Godkjenning og retur skjer i kontrollflaten. En annen enn den som utførte arbeidet må godkjenne det.',
  'avcs.panel.show': 'Vis panel',
  'avcs.panel.showing': 'Viser {account}',
  'avcs.panel.hide': 'Skjul panel',
  'avcs.portfolio.title': 'Avstemming',
  'avcs.portfolio.subtitle': 'Følg opp avstemminger på tvers av klientene dine.',
  'avcs.portfolio.viewMatrix': 'Matrise',
  'avcs.portfolio.viewTasks': 'Oppgaveliste',
  'avcs.portfolio.refresh': 'Oppdater',
  'avcs.portfolio.searchClient': 'Søk etter klient',
  'avcs.portfolio.allResponsible': 'Alle ansvarlige',
  'avcs.portfolio.allStatuses': 'Alle statuser',
  'avcs.portfolio.allDeadlines': 'Alle frister',
  'avcs.portfolio.next7': 'Neste 7 dager',
  'avcs.portfolio.deadlinePassed': 'Frist passert',
  'avcs.portfolio.next30': 'Neste 30 dager',
  'avcs.portfolio.clientGroup': 'Klientgruppe',
  'avcs.portfolio.allClientGroups': 'Alle klientgrupper',
  'avcs.portfolio.onlyMine': 'Kun mine klienter',
  'avcs.portfolio.onlyDeviations': 'Kun avvik',
  'avcs.portfolio.moreFilters': 'Flere filtre',
  'avcs.portfolio.emptyTitle': 'Ingen klienter i denne perioden',
  'avcs.portfolio.emptyText': 'Enten har byrået ingen aktive klienter ennå, eller så ligger perioden før overtakelsesdatoen deres. Overtakelsesdatoen settes per klient under Klienter.',
  'avcs.portfolio.clients': 'Klienter',
  'avcs.portfolio.kpiDone': 'Ferdig avstemt',
  'avcs.portfolio.kpiWorking': 'Under arbeid',
  'avcs.portfolio.kpiDeviations': 'Med avvik',
  'avcs.portfolio.kpiLocked': 'Låste perioder',
  'avcs.portfolio.kpiDue7': 'Frister neste 7 dager',
  'avcs.portfolio.showing': 'Viser: {filters}',
  'avcs.portfolio.openPointsIn': 'åpne punkter i {areas}',
  'avcs.portfolio.removeFilter': 'Fjern filter',
  'avcs.nav.areaTitle': '{area} — {extra}',
  'avcs.nav.contextOnly': 'Kun kontekst — området inngår ikke i denne kontrollen',
  'avcs.nav.summary': 'Oppsummering',
  'avcs.nav.otherAreas': 'Øvrige områder ({count})',
  'avcs.nav.otherAreasNote': 'Disse områdene inngår ikke i denne kontrollen og vises bare som periodekontekst.',
  'avcs.nav.showMenu': 'Vis meny',
  'avcs.nav.hideMenu': 'Skjul meny',
  'avcs.header.backToReviewInbox': 'Tilbake til kontrollinnboksen',
  'avcs.header.exportReviewBasis': 'Eksporter kontrollgrunnlag',
  'avcs.header.export': 'Eksporter',
  'avcs.header.submitForReview': 'Send hele perioden til kontroll',
  'avcs.header.reopenPeriod': 'Gjenåpne perioden',
  'avcs.header.completePeriod': 'Fullfør periode',
  'avcs.header.openRequests': '{count} åpne forespørsler',
  'avcs.header.responsible': 'Ansvarlig: {name}',
  'avcs.summary.noAccounts': 'Ingen kontoer',
  'avcs.summary.missingDocsShort': '{count} mangler dok.',
  'avcs.summary.openCount': '{count} åpne',
  'avcs.summary.colArea': 'Område',
  'avcs.summary.colCompleted': 'Fullført',
  'avcs.summary.colMissing': 'Mangler',
  'avcs.summary.noOpenDeviations': 'Ingen åpne avvik.',
  'avcs.summary.noExternalBalance': 'Ingen ekstern saldo lagt inn',
  'avcs.summary.unexplained': 'Uforklart: {amount}',
  'avcs.summary.balanceChanged': 'Bokført saldo har endret seg etter avstemming',
  'avcs.summary.balanceChangedDetail': '{accounts} — grunnlaget er ikke det samme som da kontoen ble avstemt.',
  'avcs.summary.reopenReconciliation': 'Åpne avstemmingen på nytt',
  'avcs.summary.progressByArea': 'Fremdrift per fagområde',
  'avcs.summary.openDeviations': 'Åpne avvik',
  'avcs.workspace.explanationSaved': 'Forklaringen er lagret på perioden.',
  'avcs.workspace.conclusionSaved': 'Konklusjonen er lagret.',
  'avcs.workspace.reopenPrompt': 'Hvorfor gjenåpnes perioden?',
  'avcs.workspace.sentToReview': 'Sendt til kontroll. En annen enn deg må godkjenne det.',
  'avcs.workspace.documentAttached': 'Dokumentet er lagt ved.',
  'avcs.workspace.removeConfirm': 'Fjern «{file}»? Kontoer som pekte på det står igjen uten dokumentasjon.',
  'avcs.workspace.requestSent': 'Forespørselen er sendt til klienten og lagret på perioden.',
  'avcs.workspace.requestSavedOnly': 'Forespørselen er lagret på perioden. Den ble ikke lagt i klientdialogen — si fra på annen måte.',
  'avcs.workspace.locked': 'Perioden er låst. Gjenåpning krever en begrunnelse, og den blir stående i aktivitetsloggen.',
  'avcs.workspace.noAccountsTitle': 'Ingen balansekontoer i denne perioden',
  'avcs.workspace.noAccountsText': 'Avstemming gjelder balansekontoene. Har klienten ikke bokført noe ennå, er det ingenting å avstemme.',
  'avcs.workspace.accountLabel': 'konto {id}',
  'avcs.export.noAccounts': 'Ingen kontoer å eksportere i denne perioden.',
});
